import { Flex, Text } from '@chakra-ui/core'
import { ControlledCustomSwitch } from 'components/TasksV2/UI/ControlledCustomSwitch'
import useLocaleText from 'components/useLocaleText'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'

export const SchedulePushSwitch = () => {
  const { control, watch } = useFormContext()

  const t_schedulePush = useLocaleText('enable_reminder_notification')

  return (
    <Flex alignItems="center" style={{ columnGap: '10px' }}>
      <Controller
        as={ControlledCustomSwitch}
        name="send_schedule_push"
        control={control}
        key="send_schedule_push"
        defaultValue={watch('send_schedule_push')}
        valueName="isChecked"
        size="lg"
        onChange={([event]) => {
          return event.target.checked
        }}
      />
      <Text>{t_schedulePush}</Text>
    </Flex>
  )
}
